import { c as _c } from "react/compiler-runtime";
import { AFFILIATE_PROGRAM_API } from 'modules/affiliate-program/api/affiliate-program-api';
import { CommissionApiInterface } from 'modules/affiliate-program/types/affiliate-program-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface';
import { baseFetcher } from 'shared/utils/http-client';
import useSWR from 'swr';
export function useCommissions(t0) {
  const $ = _c(11);
  const {
    limit,
    pagination
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== limit || $[2] !== pagination || $[3] !== user) {
    t2 = () => {
      if (user && pagination.startFromId === undefined && limit) {
        return `${AFFILIATE_PROGRAM_API}/affiliate-commissions/list?pagination[limit]=${limit}`;
      } else {
        if (user && pagination.startFromId && limit) {
          return `${AFFILIATE_PROGRAM_API}/affiliate-commissions/list?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}`;
        }
      }
      return null;
    };
    $[1] = limit;
    $[2] = pagination;
    $[3] = user;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data: commissions,
    mutate: mutateCommissions
  } = useSWR(t2, fetcher);
  let t3;
  if ($[5] !== user) {
    t3 = () => {
      if (user) {
        return `${AFFILIATE_PROGRAM_API}/affiliate-commissions/count`;
      }
      return null;
    };
    $[5] = user;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    data: commissionsCounter
  } = useSWR(t3, baseFetcher);
  let t4;
  if ($[7] !== commissions || $[8] !== commissionsCounter || $[9] !== mutateCommissions) {
    t4 = {
      commissions,
      mutateCommissions,
      commissionsCounter
    };
    $[7] = commissions;
    $[8] = commissionsCounter;
    $[9] = mutateCommissions;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}